<template>
	<div id="app">
		<!-- <vue-confirm-dialog style="white-space: pre-line;"></vue-confirm-dialog> -->
		<component :is="this.$route.meta.layout || 'div'">
			<router-view />
		</component>
	</div>
</template>

<script>
export default {
	name: "App",
};
</script>